/*  
  Codul de identificare fiscală – 
  CIF este un cod alfanumeric constituind identificatorul fiscal al unui comerciant. 
  Acesta poate fi bazat pe "RO" + CUI sau pe CNP.

  RO#########C
  RO este atributul fiscal
  ######### este numărul de identificare, între 1 și 9 cifre
  C este numărul de verificare, 1 cifră

  (wiki)
  */
export const isAPossibleCIF = (value: any) => {
  value = `${value}`.trim();
  ///replace all 'RO', 'ro' and 'Ro' with ''
  value = value.replace(/RO/gi, "");
  /// the result is boolean if the value is a number
  if (isNaN(value)) {
    return false;
  }
  return value.length >= 1 && value.length <= 10;
};

export const normalizeCIF = (cif: string) => {
  cif = (cif || "").trim();
  cif = cif.replace(/RO/gi, "");
  return cif;
};
